import { BodyText, Link } from '@farol-ds/react'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useEffect, useRef } from 'react'

import { ACCOUNT_LIMIT_EVENTS, HELP_CENTER_URL } from '../../constants'
import type { AuthPageEventData } from '../../utils/event-data'
import { buildUserAccountEventData } from '../../utils/event-data'
import { LoginCard } from '../login-card/login-card'
import styles from './account-limit-reached.module.scss'

export type AccountLimitReachedEventData = AuthPageEventData

export interface AccountLimitReachedProps {
  eventData: AuthPageEventData
  onCloseClick?: () => void
}

export function AccountLimitReached({
  eventData: propsEventData,
  onCloseClick,
}: AccountLimitReachedProps) {
  const eventData = useRef(buildUserAccountEventData(propsEventData)).current

  useEffect(() => {
    sendMetrics(ACCOUNT_LIMIT_EVENTS.VIEWED, null, eventData)
    const handleBeforeUnload = () => {
      sendMetrics(ACCOUNT_LIMIT_EVENTS.CLOSED, null, eventData)
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      sendMetrics(ACCOUNT_LIMIT_EVENTS.CLOSED, null, eventData)
    }
  }, [eventData])

  const handleContactClick = () => {
    sendMetrics(ACCOUNT_LIMIT_EVENTS.CONTACT_SUPPORT_CLICKED, null, eventData)
  }

  const header = {
    title: 'Limite de contas excedido',
    subtitle: {
      content: (
        <>
          Parece que você está tentando criar múltiplas contas, o que viola nossa política. Por
          isso, bloqueamos novos cadastros.
        </>
      ),
    },
  }
  return (
    <LoginCard header={header} onCloseClick={onCloseClick}>
      <div className={styles.content}>
        <BodyText className={styles.bodyText}>
          Se acreditar que isso é um engano, entre em contato com a{' '}
          <Link
            href={HELP_CENTER_URL}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleContactClick}
          >
            Central de Ajuda
          </Link>
        </BodyText>
      </div>
    </LoginCard>
  )
}
